import React, { useEffect } from 'react'
import { string } from 'prop-types'

const PrnewswireWidget = ({ newswireId }) => {
  useEffect(() => {
    const script = document.createElement('script')

    script.src = `//tools.prnewswire.com/en-us/live/${newswireId}/landing.js`
    script.async = true

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [newswireId])

  return <div id={`w${newswireId}_landing`}>&nbsp;</div>
}

PrnewswireWidget.propTypes = {
  newswireId: string
}

export default PrnewswireWidget
